import { handleErrors } from '.';

import type { TimelineForm } from '../types/forms/timelineform';
import type { ShareFormData } from '../types/forms/shareform';

interface TimelineAPIParams {
  page?: number;
  per_page?: number;
  search?: string;
  contributing?: number | boolean;
};

export const APIcreateTimeline = async (data: TimelineForm) => (
  window.axios.post('/api/timelines', data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIupdateTimeline = async (timelineId: string, data: TimelineForm) => (
  window.axios.patch(`/api/timelines/${timelineId}`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchTimeline = async (timelineId: string) => (
  window.axios.get(`/api/timelines/${timelineId}`)
    .then((response) => (response.data))
    .catch((error) => error)
);

export const APIfetchTimelines = async (params: TimelineAPIParams = {}) => (
  window.axios.get('/api/timelines', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIshareTimeline = async (timelineId: string, data: ShareFormData) => (
  window.axios.post(`/api/timelines/${timelineId}/shares`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIregisterTimelineView = async (timelineId: number) => (
  window.axios.post(`/api/timelines/${timelineId}/views`)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchContributorInvitations = async () => (
  window.axios.get('/api/timelines/invitations')
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIinviteTimelineContributor = async (timelineId: string, email: string) => (
  window.axios.post(`/api/timelines/${timelineId}/contributors`, { email })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIacceptTimelineContributor = async (timelineId: string, contributorId: string) => (
  window.axios.patch(`/api/timelines/${timelineId}/contributors/${contributorId}/accept`)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIdeclineTimelineContributor = async (timelineId: string, contributorId: string) => (
  window.axios.patch(`/api/timelines/${timelineId}/contributors/${contributorId}/decline`)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);
